import React from 'react';

import { Margin, Stack } from '@ovotech/element-v4';
import { Section } from '@/src/components';
import { REWARDS_SECTION_ID } from '@/src/constants/sectionIds';
import {
  BeyondCard,
  CardText,
  CardTitle,
  GridContainer,
  IconWrapper,
  SectionHeading,
} from './styles';
import { useRewardsCardsContent } from './hooks/useRewardsCardsContent';
import { AnalyticsPotentialClick } from './AnalyticsPotentialClick';

export const Rewards = () => {
  const { cardsContent } = useRewardsCardsContent();

  if (!cardsContent?.length) return null;

  return (
    <Section id={REWARDS_SECTION_ID}>
      <Margin top={[0, 4, 4]}>
        <SectionHeading>
          Perks <span>of staying with us</span>
        </SectionHeading>
      </Margin>
      <Margin vertical={[4, 8, 8]}>
        <GridContainer>
          {cardsContent.map(({ Icon, title, text }, index) => (
            <BeyondCard key={index}>
              <Stack spaceBetween={2}>
                <IconWrapper>
                  <Icon aria-hidden="true" />
                </IconWrapper>
                <CardTitle>{title}</CardTitle>
                <CardText>{text}</CardText>
              </Stack>
              <AnalyticsPotentialClick customLabel={title} />
            </BeyondCard>
          ))}
        </GridContainer>
      </Margin>
    </Section>
  );
};
